import React from 'react';

const Footer = props => (
	<div
		className="footer"
		style={{ position: 'fixed', bottom: '0', width: '100%' }}
	>
		<nav className="navbar navbar-expand-lg navbar-dark bg-dark">
			<div className="container">
				<ul className="navbar-nav mr-auto">
					<li className="nav-item">
						<a href="http://www.ibrahim.com.co/" className="nav-link" target="_blank" rel="noopener noreferrer">
							Ibrahim Consumer Behavior
						</a>
					</li>
				</ul>
			</div>
		</nav>
	</div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js